import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from "@angular/core";

import { MapsAPILoader } from '@agm/core';
import { ControlContainer, FormGroupDirective, FormGroup, FormControl, ControlValueAccessor, Validators } from '@angular/forms';
import { Address } from "../../models/address.model";

@Component({
  selector: "app-google-places",
  templateUrl: "./google-places.component.html",
  styleUrls: ["./google-places.component.scss"],
  viewProviders: [
    {
        provide: ControlContainer,
        useExisting: FormGroupDirective
    }
  ]
})

export class GooglePlacesComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() addressType: string;
  @Input() controlName: string;
  @Input() removeStyle: boolean = false;
  @Input() placeholder: string = 'Enter an address';
  @Input() initialValue: Address;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('search') searchElementRef: ElementRef;
  childForm: FormGroup;
  addressSet: boolean;

  constructor(private mapsAPILoader: MapsAPILoader, private parentF: FormGroupDirective) {}

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    this.childForm.addControl(this.controlName, new FormControl(null, Validators.required));
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  private getPlaceAutocomplete() {
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: [this.addressType]
      });

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.addressSet = true;
        this.invokeEvent(place);
      });

      if (this.initialValue) {
        this.childForm.get(this.controlName).setValue(this.initialValue.getFullAddress());
        this.childForm.get(this.controlName).updateValueAndValidity();
        this.addressSet = true;
      }
    });
  }

  invokeEvent(place: google.maps.places.PlaceResult) {
    this.writeValue(place.formatted_address);
    this.setAddress.emit(place);
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.childForm.get(this.controlName).setValue(value);
      this.childForm.get(this.controlName).updateValueAndValidity();
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.addressSet) {
        this.childForm.get(this.controlName).setValue(null);
      }
    }, 200);
  }

  onValueChanged() {
    this.addressSet = false;
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }
}
